const SESSION_KEY = 'rr_session_id';

export const getSessionId = (): string => {
  const existing = sessionStorage.getItem(SESSION_KEY);
  if (existing) {
    return existing;
  }

  const id = crypto.randomUUID();
  sessionStorage.setItem(SESSION_KEY, id);
  return id;
};

export const appendSessionId = (url: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}rr_session_id=${getSessionId()}`;
};
